import qs from 'qs';
import { AxiosResponse } from 'axios';
import {
  Occurrence,
  OccurrenceList,
  OccurrenceListView,
  OccurrenceView,
  Pagination,
} from '~/types';
import { formatInTimeZone } from '~/utils/formatToTimeZone';
import apiAssist from '~/utils/apiAssist';
import { QueryFilterContext } from '~/hooks/useFilter/types';

export function addFormattedPropertiesToOccurence(
  occurrence: Occurrence,
): OccurrenceView {
  return {
    ...occurrence,
    formattedStatus: occurrence.dt_encerramentochamado ? 'ENCERRADO' : 'ABERTO',
    colorScheme: occurrence.ds_solucaoaplicada ? 'red' : 'green',
    status: !occurrence.ds_solucaoaplicada,

    formattedClosingDate: occurrence?.dt_encerramentochamado
      ? formatInTimeZone(
          `${occurrence.dt_encerramentochamado}T00:00:00Z`,
          'dd/MM/yyyy',
        )
      : '',
    formattedOpeningDate: formatInTimeZone(
      `${occurrence.dt_aberturachamado}T00:00:00Z`,
      'dd/MM/yyyy',
    ),
  };
}

export async function getOccurrences(
  page: number,
  orderby: string,
  order: string,
  search: string,
  query?: any,
  pageSize?: number,
): Promise<Pagination<OccurrenceListView>> {
  const { data } = await apiAssist.get<Pagination<OccurrenceList>>(
    '/chamados',
    {
      params: {
        page,
        orderby,
        order,
        size: pageSize,
        ...(search ? { search } : {}),
        ...{ ...query },
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    },
  );

  const occurrences = data.results.map(occurrence => {
    return {
      ...occurrence,
      ...occurrence,
      formattedStatus: occurrence.dt_encerramentochamado
        ? 'ENCERRADO'
        : 'ABERTO',
      formattedClosingDate: occurrence?.dt_encerramentochamado
        ? formatInTimeZone(
            `${occurrence.dt_encerramentochamado}T00:00:00Z`,
            'dd/MM/yyyy',
          )
        : '',
      formattedOpeningDate: formatInTimeZone(
        `${occurrence.dt_aberturachamado}T00:00:00Z`,
        'dd/MM/yyyy',
      ),
    };
  });

  return {
    ...data,
    results: occurrences,
  };
}

export async function getOccurrenceById(id: string): Promise<OccurrenceView> {
  const { data } = await apiAssist.get<Occurrence>(`/chamados/${id}`);

  const occurrence = addFormattedPropertiesToOccurence(data);

  return occurrence;
}

export async function getOccurrencesXlsx(
  search: string,
  orderby: string,
  order: string,
  query?: QueryFilterContext,
): Promise<AxiosResponse<any>> {
  const url = '/chamados/xlsx';
  const groups = query?.groups?.map(e => e.value);
  const headoffices = query?.headOffices?.map(e => e.value);
  const branches = query?.branches?.map(e => e.value);
  return apiAssist.get(url, {
    params: {
      ...(search && { search }),
      ...(orderby && { orderby }),
      ...(order && { order }),
      ...(groups && { groups }),
      ...(headoffices && { headoffices }),
      ...(branches && { branches }),
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    headers: {
      'Content-Type': 'application/xlsx',
    },
    responseType: 'blob' as 'json',
  });
}
